//TODO: Add more to this method for other invalid field type not just value missing
//TODO: Add more support for customizing error messages based on type of error and not require a slotted error in the component
//The prerequisite for this method is that the form is a direct child of the target
//To use this method there must be slotted content for the error message
export const validateBeaconForm = (form) => {
  const { target } = form;
  if (target instanceof HTMLFormElement) {
    const { elements } = target;
    Array.from(elements).forEach((control) => {
      if (control.getAttribute('aria-disabled') === 'true') return;
      if (control instanceof HTMLInputElement) {
        try {
          const validity = control.validity;
          control.checkValidity();

          const { valueMissing } = validity;

          if (valueMissing) {
            control.setAttribute('aria-invalid', 'true');
          } else {
            control.setAttribute('aria-invalid', 'false');
          }
        } catch (error) {
          console.error(error, control);
        }
      }
    });
  }
};
